import React, { Component } from 'react';
import {Link} from 'react-router';
import {DeleteDialog} from 'modules/dialog';
import {CheckPermission} from 'modules/login/CheckPermission';
import {get} from 'lodash';

class RowItemNhomDoiTuongThanhTra extends Component {
  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>{get(this.props.item, 'ten')}</td>
        <td>{get(this.props.item, 'moTa')}</td>
        <td>
          <div className="todo-wrap two-item">          
            {
              CheckPermission('DOITUONGTHANHTRA_SUA') &&
              <Link
                className="itt-edit"
                onClick={this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)}>
                Chỉnh sửa
              </Link>
            }
            {
              CheckPermission('DOITUONGTHANHTRA_XOA') &&
              <DeleteDialog
                title='Xoá danh mục'
                content='Bạn chắc chắn muốn xoá danh mục này?'
                redux={this.props.parent}
                deleteId={this.props.item.nhomDoiTuongThanhTraId}
              />
            }
          </div>
        </td>
      </tr>
    )
  }
}

export default RowItemNhomDoiTuongThanhTra


// WEBPACK FOOTER //
// ./src/components/modules/category/datatable/list/RowItemNhomDoiTuongThanhTra.jsx